var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ready-contents" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("h5", [_vm._v(_vm._s(_vm.$t("plans.readyContents")))]),
        _vm._v(" "),
        _c("div", { staticClass: "search-bar" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            attrs: { type: "text", placeholder: "Ara..." },
            domProps: { value: _vm.searchQuery },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchQuery = $event.target.value
                },
                _vm.filterContents,
              ],
            },
          }),
          _vm._v(" "),
          _c("i", { staticClass: "material-icons" }, [_vm._v("search")]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.filteredReadyContents, function (group) {
        return _c(
          "div",
          { key: group._id, staticClass: "ready-contents-group" },
          [
            _c(
              "div",
              {
                staticClass: "ready-contents-group-head",
                on: {
                  click: function ($event) {
                    return _vm.toggleActive(group._id)
                  },
                },
              },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.getContentFromLanguage(group, "name"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.isActive(group._id)
                          ? "arrow_drop_up"
                          : "arrow_drop_down"
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ready-contents-group-content",
                class: { active: _vm.isActive(group._id) },
                style: {
                  "--items": group.children.length,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "ready-contents-group-content-items" },
                  _vm._l(group.children, function (item) {
                    return _c(
                      "div",
                      {
                        key: item._id,
                        staticClass: "ready-contents-group-item",
                        on: {
                          click: function ($event) {
                            return _vm.triggerReadyContent(item, "content")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ready-content-key" }, [
                          _vm._v(_vm._s(_vm.getPressKey(item))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  theme: "light",
                                  arrow: true,
                                  placement: "bottom",
                                },
                                expression:
                                  "{ followCursor: true, theme: 'light', arrow: true, placement: 'bottom' }",
                              },
                            ],
                            staticClass: "ready-content-val",
                            attrs: {
                              content: _vm.getContentFromLanguage(item),
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getContentFromLanguage(item)) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }